const apiUrls = {
  top: 'https://api.jikan.moe/v4/top/anime?',
  upcoming: 'https://api.jikan.moe/v4/seasons/upcoming?',
  season: 'https://api.jikan.moe/v4/seasons/now?',
  genres: 'https://api.jikan.moe/v4/genres/anime?',
  search: 'https://api.jikan.moe/v4/anime?',
};

export default apiUrls;
